import React, { Fragment, PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Swal from "sweetalert2";

import { SiteRutas } from "../../request/RutasConfig";
import { Zona_Eliminar, Zona_Lista } from "../../request/MantenimientosRequest";
import { Obtener_CallCenter_Empresa_Request } from "../../request/ParametroRequest";
import { Obtener_MenuOpciones } from "../../request/MenuRequest";

import { Notificacion } from "../../components/Util/Notificacion/Notificacion";

import ZonasItfz from "./Interfaz/ZonasItfz.jsx";

class Zonas extends PureComponent {
  _isMounted = false;

  state = {
    Datos: {
      titulo: "Lista de Zonas",
      CC_id: {
        value: 0,
        attributes: {
          readOnly: true,
          focus: false,
          hidden: "unset",
          label: "Call Center:",
          id: "CC_id"
        }
      },
      busqueda: {
        value: "",
        attributes: {
          focus: false,
          hidden: "unset",
          label: "",
          id: "busqueda"
        }
      }
    },
    listaCallCenter: [],
    listaCallCenterOrig: [],
    listaZonasOrig: [],
    listaZonas: [],
    selectedZona: 0,
    selectedCC: 0,
    disabled: {
      Acciones: true,
      HabilitarAplicar: ""
    },
    buscar: "",
    menuId: 0,
    menuOpciones: [],
    showModalSeguridad: false,
    opcionValidar: 0,
    opcionSeleccionada: 1,
    autorizado: false,
    accion: 1,
    CadenaId: 0,
    paginaActual: 1,
    cantidadRegistrosPaginaTabla: 10
  }

  componentDidMount = async () => {
    this._isMounted = true;

    let menuId = 0;
    if (this.props.location.state) {
      menuId = this.props.location.state.menuId;
    }

    let menuOpciones = null;
    if (menuId > 0) {

      let response = await Obtener_MenuOpciones(this.props.token, menuId);
      if (response.Exitoso) {
        menuOpciones = response.Datos;
      } else {
        Notificacion.error(response.Mensaje);
      }
    }

    let listaCallCenter = [{ Id: 0, Nombre: "Seleccione una opción" }];

    let response = await Obtener_CallCenter_Empresa_Request(this.props.token, this.props.empresa.Id);
    if (response.Exitoso) {
      let listaCallCenterOrig = response.Datos;

      response.Datos.forEach((item) => {
        listaCallCenter.push({ Id: item.Id, Nombre: item.Nombre });
      });

      this._isMounted && this.setState({ listaCallCenter, listaCallCenterOrig, menuId, menuOpciones });
    } else {
      Notificacion.error(response.Mensaje);
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  validarMenuOpcion = () => {
    let validar = false;
    let autorizado = this.state.autorizado;
    let menuOpciones = this.state.menuOpciones;
    let resultado = menuOpciones.filter(item => item.Opcion_Id === 1);

    if (resultado.length > 0) {
      if (resultado[0].Validar && !autorizado) {
        this._isMounted && this.setState({ showModalSeguridad: true, opcionValidar: resultado[0].Opcion_Id });
        validar = true;
      } else {

        validar = false;
      }
    } else {

      this._isMounted && this.setState({ showModalSeguridad: true, opcionValidar: 1 });
      validar = true;
    }

    return validar;
  }

  cambiarTamanioPagina = (cantidad) => {
    this.setState({ cantidadRegistrosPaginaTabla: cantidad });
  }

  cambiarPagina = (pagina) => {
    this.setState({ paginaActual: pagina });
  }

  onActionResultModal = (pValido) => {
    if (pValido) {
      const opcionValidar = this.state.opcionValidar;
      this.setState({
        showModalSeguridad: false,
        opcionSeleccionada: opcionValidar,
        opcionValidar: 0,
        autorizado: pValido
      },
        () => {
          if (this.state.accion === 1) {
            this.ingresarDatos();
          } else {
            this.actualizarDatos();
          }
        }
      );
    }
  }

  handleCerrarModal = () => this.setState({ showModalSeguridad: false });

  validaSeleccionado = () => {
    let id = this.state.selectedZona;
    if (id) {
      return true;
    } else {
      Notificacion.error("Debe seleccionar un registro.");
      return false;
    }
  }

  actualizarDatos = () => {
    let validar = this.validarMenuOpcion();

    this._isMounted && this.setState({ accion: 2 });
    
    if (!validar) {
      let id = this.state.selectedZona;
      let CC_id = this.state.Datos.CC_id.value;
      let menuId = this.state.menuId;

      if (CC_id > 0) {
        if (this.validaSeleccionado()) {

          this.props.history.push({
            pathname: `${SiteRutas.ZonasMantenimiento}/${id}/${CC_id}`,
            state: { menuId: menuId }
          });
        }
      } else {
        Notificacion.error("Error: Debe seleccionar un Call Center.");
      }
    }
  }

  ingresarDatos = () => {
    let validar = this.validarMenuOpcion();

    this._isMounted && this.setState({ accion: 1 });

    if (!validar) {
      let id = 0;
      let CC_id = this.state.Datos.CC_id.value;
      let menuId = this.state.menuId;

      if (CC_id > 0) {

        this.props.history.push({
          pathname: `${SiteRutas.ZonasMantenimiento}/${id}/${CC_id}`,
          state: { menuId: menuId }
        });
      } else {
        Notificacion.error("Error: Debe seleccionar un Call Center");
      }
    }
  }

  borrarDatos = async () => {
    let id = this.state.selectedZona;
    let CC_id = this.state.selectedCC;

    if (this.validaSeleccionado()) {
      const resultado = await Zona_Eliminar(this.props.token, this.props.empresa.Id, CC_id, id);

      if (resultado.Exitoso) {
        Notificacion.success("Se eliminó con éxito.");

        if (this.state.Datos.CC_id.value > 0) {

          const response = await Zona_Lista(this.props.token, this.props.empresa.Id, this.state.Datos.CC_id.value);
          if (response.Exitoso) {
            let paginaActual = this.state.paginaActual;
            if (paginaActual > 1 && ((paginaActual - 1) * this.state.cantidadRegistrosPaginaTabla) >= response.Datos.length) {
              paginaActual--;
            }

            this._isMounted &&
              this.setState({
                listaZonas: response.Datos,
                listaZonasOrig: response.Datos,
                selectedZona: "",
                paginaActual
              });
          } else {
            Notificacion.error(response.Mensaje);
          }
        }
      } else {
        Notificacion.error("Error: " + resultado.Mensaje);
      }
    }
  }

  handleBorrar = () => {
    let resultado = false;
    if (this.validaSeleccionado()) {
      Swal.fire({
        title: "Eliminar Zona",
        html: "<h4>¿Está seguro que desea eliminar la Zona?</h4>",
        showCancelButton: true,
        confirmButtonText: "<h5>Sí</h5>",
        cancelButtonText: "<h5>No</h5>",
        reverseButtons: true,
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          resultado = true;
          this.borrarDatos();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          resultado = false;
        }
      });
      if (this._isMounted) {
        this.setState({ borrando: false });
      }
    }
    return resultado;
  }

  onRowSelect = (row, isSelected) => {
    let Datos = { ...this.state.Datos };
    Datos.CC_id.value = 0;

    let disabled = { ...this.state.disabled };
    disabled.Acciones = !isSelected;

    let selectedZona = 0;

    if (isSelected) {
      Datos.CC_id.value = row.CC_id;
      selectedZona = row.Id;
    }

    this._isMounted && this.setState({ selectedZona, selectedCC: row.CC_id, disabled, Datos });
  };

  onDoubleClick = (e, row, rowIndex) => {
    let Datos = { ...this.state.Datos };
    Datos.CC_id.value = row.CC_id;

    this.setState({ selectedZona: row.Id, Datos }, () => {
      this.actualizarDatos();
    });
  };

  filtrarRegistro = (event) => {
    const { value } = event.target;
    const { listaZonasOrig } = this.state;
    let Datos = { ...this.state.Datos };
    Datos.busqueda.value = value.trim();

    this._isMounted && this.setState({ Datos });

    let result = [];
    let listaZonas = [];

    if (value.trim().length > 0) {
      listaZonas = listaZonasOrig.filter(item =>
        item.Nombre.toUpperCase().indexOf(value.toUpperCase().trim()) != -1
      );

      result = listaZonasOrig.filter(item => item.Id == value.trim());

      if (result.length > 0) {
        listaZonas = listaZonas.concat(result).reduce((newArray, item) => {
          if (newArray.includes(item)) {
            return newArray;
          } else {
            return [...newArray, item];
          }
        }, []);
      }

      this._isMounted && this.setState({ listaZonas });
    } else {
      if (this._isMounted) {
        this.setState({ listaZonas: listaZonasOrig });
      }
    }
  }

  onFocusInput = (event) => {
    // event.target.value = this.state.buscar;
  };

  onSelectChanged = async (event) => {
    const { name, value } = event.target;

    let newAttributes = this.state.Datos[name].attributes;
    const Datos = Object.assign({}, this.state.Datos, {
      [name]: { value: value, attributes: newAttributes }
    });

    if (value > 0) {

      const response = await Zona_Lista(this.props.token, this.props.empresa.Id, value);
      if (response.Exitoso) {
        this._isMounted && this.setState({ listaZonas: response.Datos, listaZonasOrig: response.Datos });
      } else {
        Notificacion.error(response.Mensaje);
      }
    }

    this._isMounted && this.setState({ Datos });
  };

  render() {
    const { Datos, listaZonas, listaCallCenter, menuId, opcionValidar, showModalSeguridad, paginaActual } = this.state;

    return (
      <Fragment>
        <ZonasItfz
          token={this.props.token}
          menuId={menuId}
          opcionValidar={opcionValidar}
          showModalSeguridad={showModalSeguridad}
          onActionResultModal={this.onActionResultModal}
          handleCerrarModal={this.handleCerrarModal}
          listaZonas={listaZonas}
          listaCallCenter={listaCallCenter}
          Datos={Datos}
          onDoubleClick={this.onDoubleClick}
          onRowSelect={this.onRowSelect}
          actualizarDatos={this.actualizarDatos}
          ingresarDatos={this.ingresarDatos}
          handleBorrar={this.handleBorrar}
          filtrarRegistro={this.filtrarRegistro}
          onFocusInput={this.onFocusInput}
          onSelectChanged={this.onSelectChanged}
          paginaActual={paginaActual}
          onPageChange={this.cambiarPagina}
          onSizePerPageChange={this.cambiarTamanioPagina}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.usuario.token,
    empresa: state.parametros.empresa,
  };
};

export default connect(mapStateToProps)(withRouter(memo(Zonas)));
